import { useState } from 'react'

import { Box, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import EsignaturePlacementFile from 'modules/documents/components/EsignaturePlacementFile'
import { Stamp } from 'modules/documents/components/EsignaturePlacementFile/constants'
import { WizardData } from 'modules/documents/components/UploadFormWizard/types'

interface Props {
  showValidations: boolean
}

const EsignaturePlacement = ({
  data,
  onDataChanged,
  showValidations,
}: Props & WizardStepRenderParams<WizardData>) => {
  const { files, additionalSignersAccessIds, signatureStamps } = data
  const [currentFileIndex, setCurrentFileIndex] = useState(0)

  const stampsPending = useUnsafeMemo(() => {
    const stampsByFileId = signatureStamps.reduce<Record<number, Stamp[]>>((acc, stamp) => {
      if (!acc[stamp.fileId]) {
        acc[stamp.fileId] = []
      }
      acc[stamp.fileId]?.push(stamp)
      return acc
    }, {})

    const haveFilesAllStamps = files.map((_, index) => {
      const signerIds = new Set(stampsByFileId[index]?.map((stamp) => stamp.signer.id))
      return !additionalSignersAccessIds.every((signerId) => signerIds.has(signerId))
    })

    return haveFilesAllStamps
  }, [signatureStamps, files, additionalSignersAccessIds])

  const onChange = (newSignatureStamps: Stamp[]) => {
    onDataChanged({ ...data, signatureStamps: newSignatureStamps })
  }

  const goToPreviousFile = () => {
    setCurrentFileIndex((prevIndex) => Math.max(prevIndex - 1, 0))
  }

  const goToNextFile = () => {
    setCurrentFileIndex((prevIndex) => Math.min(prevIndex + 1, files.length - 1))
  }

  return (
    <Box height="full">
      {files[currentFileIndex] && (
        <EsignaturePlacementFile
          file={files[currentFileIndex]}
          fileId={currentFileIndex}
          signerIds={additionalSignersAccessIds}
          onChangeStamps={onChange}
          goToPreviousFile={goToPreviousFile}
          goToNextFile={goToNextFile}
          currentFileIndex={currentFileIndex}
          totalFiles={files.length}
          pendingStampsToPlace={stampsPending}
          showValidations={showValidations}
        />
      )}
    </Box>
  )
}

export default EsignaturePlacement
